import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import SelectionAssigned from '../Entered/SelectionAssigned';
import PrizeDrawCard from '../PrizeDrawCard';
import CrossPromoCards from '../CrossPromoCards';
import { useSportConfig } from '../../hooks/useSportConfig';

const Winners = ({
    title,
    eventName,
    winners,
    entry,
    didEntryWin,
    TermsLink,
    Itv7TermsLink,
    prize
}) => {
    const { config, SelectionCard, mapSelectionToCardProps } = useSportConfig();
    const showPlayItv = config.features.hasPlayItvCta;
    const sportType = config.type;

    return (
        <>
            <Styled.Title>{title} SWEEPSTAKE</Styled.Title>
            <Styled.SubHeading>{eventName} Winner</Styled.SubHeading>
            <Styled.WinnerCards>
                {winners.map(winner => (
                    <SelectionCard
                        key={winner.id}
                        // eslint-disable-next-line react/jsx-props-no-spreading
                        {...mapSelectionToCardProps(winner)}
                    />
                ))}
            </Styled.WinnerCards>
            {!didEntryWin && entry && (
                <SelectionAssigned
                    title={title}
                    selection={entry}
                    excludeFromBetting
                    bettingEnabled
                />
            )}
            <PrizeDrawCard
                eventName={eventName}
                TermsLink={TermsLink}
                hadEntry
                didEntryWin={didEntryWin}
                prize={prize}
            />
            {showPlayItv && (
                <>
                    <Styled.PlayItvHeading>
                        More from ITV7
                    </Styled.PlayItvHeading>
                    <Styled.PlayItvWrapper>
                        <CrossPromoCards
                            currentSport={sportType}
                            buttonText="PLAY ITV7"
                            TermsLink={Itv7TermsLink}
                        />
                    </Styled.PlayItvWrapper>
                </>
            )}
        </>
    );
};

Winners.defaultProps = {
    winners: [],
    entry: {}
};

Winners.propTypes = {
    title: PropTypes.string.isRequired,
    eventName: PropTypes.string.isRequired,
    winners: PropTypes.arrayOf(PropTypes.shape({})),
    didEntryWin: PropTypes.bool.isRequired,
    entry: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        metaData: PropTypes.shape({})
    }),
    TermsLink: PropTypes.func.isRequired,
    Itv7TermsLink: PropTypes.func.isRequired,
    prize: PropTypes.string.isRequired
};

export default Winners;
